import { useNavigate, useParams } from 'react-router-dom';
import { Loading } from 'framework/ui/mui-builder';

import ClientUsersListContent from './ClientUsersListContent';
import { ProjectClientPortalData } from '../types';
import ClientUsersListSection from './ClientUsersListSection';
import ClientInvitationRequestsList from './ClientInvitationRequestsList';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  useNewProjectUrl,
  useProjectSecurityContext,
} from 'domain/shared/newProject';

type ClientUsersListProps = {
  clientPortalData: ProjectClientPortalData;
  isActiveRequestsLoading: boolean;
};

const ClientUsersList = ({ clientPortalData, isActiveRequestsLoading }: ClientUsersListProps) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getProjectClientPortalInviteUrl } = useNewProjectUrl();
  const { isAccessGranted } = useProjectSecurityContext();

  const clientUsers = clientPortalData.clientPortalUsers || [];
  const activeRequests = clientPortalData.clientPortalRedmineRequests || [];
  const hasClientUsers = clientUsers.length > 0;
  const hasActiveRequests = activeRequests.length > 0;
  const canManageClientPortal = isAccessGranted(ACCESS_INFO_SECTIONS.CLIENT_PORTAL, ACCESS_INFO_ACTIONS.MANAGE);
  const canReviewClientPortal = isAccessGranted(ACCESS_INFO_SECTIONS.CLIENT_PORTAL, ACCESS_INFO_ACTIONS.REVIEW);

  const openInviteDrawer = () => navigate(getProjectClientPortalInviteUrl(id), { preventScrollReset: true });

  return (
    <ClientUsersListSection
      title="Client users"
      content={
        isActiveRequestsLoading ? (
          <Loading isInitialPosition />
        ) : (
          <>
            <ClientUsersListContent hasClientUsers={hasClientUsers} openInviteDrawer={openInviteDrawer} />
            {hasActiveRequests && (canReviewClientPortal || canManageClientPortal) && <ClientInvitationRequestsList />}
          </>
        )
      }
    />
  );
};

export default ClientUsersList;
